// extracted by mini-css-extract-plugin
module.exports = {"ether":"ether_ether__natd3","image":"ether_image__17tKZ","btn":"ether_btn__aevYZ","time":"ether_time__Rd2JW","title":"ether_title__OUxqx","section":"ether_section__iLanY"};